import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDataSourcePathCommand } from 'interfaces-lib';
import { last, mergeMap, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { IFileDataSourceApiService } from '../types/idatasourceservice';

@Injectable({
  providedIn: 'root',
})
export class PresignedUploadService implements IFileDataSourceApiService {
  private readonly PRESIGNED_NAMESPACE = 'S3';

  constructor(private http: HttpClient) {}

  postFile(file: File, fileParams: any): Observable<IDataSourcePathCommand> {
    return this.getPresignedUrl(fileParams.path).pipe(
      mergeMap((presigned) => this.putFileDataWrapper(file, presigned))
    );
  }

  checkFile(id: string): Observable<boolean> {
    return of(true);
  }

  private getPresignedUrl(path: string): Observable<IDataSourcePathCommand> {
    const url = `${environment.kpHost}/file/presigned/${this.PRESIGNED_NAMESPACE}/${path}`;
    return this.http.get<any>(url);
  }

  private putFileDataWrapper(
    file: File,
    presigned: IDataSourcePathCommand
  ): Observable<IDataSourcePathCommand> {
    // don't care about return value of aws put, need the path from the IDataSourcePathCommand
    return this.putFileData(file, presigned).pipe(
      tap((event: any) => {
        // todo: report file upload progress to user
        const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
        console.log(`File is ${percentDone}% uploaded.`);
      }),
      last(),
      map((_) => {
        return { namespace: this.PRESIGNED_NAMESPACE, path: presigned.path };
      })
    );
  }

  private putFileData(file: File, presigned: IDataSourcePathCommand): any {
    const s3Url: string = presigned?.parameters?.url as unknown as string;
    if (!s3Url) {
      throw new Error('No S3 URL found in presigned URL');
    }

    const headers = new HttpHeaders({
      'Content-Type': file.type,
    });

    return this.http.put(s3Url, file, {
      headers,
      reportProgress: true,
      observe: 'events',
    });
  }
}
